// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"500":"react-plotly-factory","710":"plotly-basic"}[chunkId] + "." + {"500":"2e96b","710":"2ad44"}[chunkId] + ".bundle.js";
};